import { Outlet } from "react-router-dom";

// styles
import styles from "./MainLayout.module.scss";
import "./Modal/modal.scss"

// component
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

export default function MainLayout() {
  return (
    <div className={styles["main-layout-root"]}>
      <Header />
      <main className={styles["main-content"]}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
